import { newsletterFormValidator } from "../../utils";
import { useState } from "preact/compat";
import Cookies from "js-cookie";
import { api } from "../../services";
import {useBehavioralContext} from "../../contexts";

export const useNewsletterForm = (props) => {
    // Destructured props
    const {setIsOpen} = props;

    // State to declare the initial form values and fields
    const [initialValues] = useState({
        name: "",
        email: ""
    })
    // State to store all the form values
    const [formValues, setFormValues] = useState(initialValues);
    // State to store all form errors
    const [errors, setErrors] = useState(initialValues);
    // State to control the form submission loading state
    const [isLoading, setIsLoading] = useState(false);

    // Newsletter feature data
    const {
        setNewsLetterSubmitted
    } = useBehavioralContext();

    // Form validator methods
    const {
        validateForm,
        validateAll
    } = newsletterFormValidator({
        formValues
    });

    // Method to handle all the input value changes
    const handleChange = e => {
        // Destructured props
        const { name, value } = e.target;

        // Assigns the new values to the formValues state
        setFormValues(prevState => {
            return {
                ...prevState,
                [name]: value
            }
        })

        // Validates the value during input time
        setErrors(prevState => {
            return {
                ...prevState,
                ...validateForm({
                    target: name,
                    value
                })
            }
        })
    }

    // Method to handle the form submission
    const handleSubmit = e => {
        // Prevents the whole page from reloading
        e.preventDefault();

        // Validates all fields at once
        const formValidation = validateAll();

        // Appends the validated fields to the error state
        setErrors(formValidation);

        // Checks if there's any error in the form and, if so, returns the method
        for (let i = 0; i < Object.values(formValidation).length; i++) {
            if (Object.values(formValidation)[i]) {
                return;
            }
        }

        // If validation is successful, then it does what it has to
        submitNewsletter().then(() => { });
    }

    // Method to actually post data to the backend
    const submitNewsletter = async () => {
        try {
            setIsLoading(true);

            // Performs the request to the backend
            let response = await api.post("/subscription", formValues);

            // If there's any error, then it does nothing
            if (response.data.error) {
                setIsLoading(false);

                return;
            }

            // Sets the cookie to flag that the submission has been made
            Cookies.set("newsletter_subscription_success", JSON.stringify({
                status: "ok",
                message: "Obrigado por sua assinatura na newsletter!"
            }))

            // Deactivates the loading state
            setIsLoading(false);

            setNewsLetterSubmitted(true);
            setFormValues(initialValues);
            setIsOpen(false);
            
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // Smoothes the scroll animation
            });
        } catch (err) {
            console.error("Error while submitting to newsletter:", err);

            // Deactivates the loading state
            setIsLoading(false);
        }
    }

    return {
        formValues,
        errors,
        isLoading,
        handleChange,
        handleSubmit
    }
}